import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL } from '../constants/api'
import setAuthorization from '../utils/helpers/setAuthorization'

const onboardingRepository = createApi({
	reducerPath: 'onboardingRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['OnboardingStudent'],

	endpoints: (builder) => ({
		progressStudent: builder.mutation<
			void,
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			{
				id: number
				step: number
				curso_id?: number
				proficiencia_id?: number
				skip: boolean
			}
		>({
			query: ({ id, ...body }) => ({
				url: `/v1/user/${id}/edit-onboarding`,
				method: 'PATCH',
				body: {
					nivel_onboarding: body.step + 1,
					curso_id: body.curso_id,
					proficiencia_id: body.proficiencia_id,
				},
			}),
			invalidatesTags: ['OnboardingStudent'],
		}),
	}),
})

export default onboardingRepository
